import { ARCustomer, InvoiceExpandedSummary } from '@melio/ar-domain';
import { Drawer, Loader } from '@melio/penny';
import { useAnalyticsView } from '@melio/platform-analytics';
import { forwardRef } from '@melio/platform-utils';
import React from 'react';

import { InvoiceActionsHandlers } from '../../../utils';
import { DrawerFooter, DrawerHeader, InvoiceSummary } from '../components';

export type InvoiceDrawersActivityProps = {
  customer?: ARCustomer;
  expandedInvoice?: InvoiceExpandedSummary;
  isOpen: boolean;
  isLoading: boolean;
  onCloseButtonClick: () => void;
  onClose: VoidFunction;
  invoiceActions: InvoiceActionsHandlers;
};

export const InvoiceDrawerScreen = forwardRef<InvoiceDrawersActivityProps>(
  ({ invoiceActions, onCloseButtonClick, expandedInvoice, customer, isLoading, isOpen, onClose: onCloseComplete }) => {
    useAnalyticsView('Invoice', !isLoading, true, {
      ProductName: 'ar',
      PageName: 'dashboard-drawer',
      Flow: 'manage-invoice',
      Intent: 'invoice-drawer',
    });

    return (
      <Drawer
        isOpen={isOpen}
        onClose={onCloseButtonClick}
        onCloseComplete={onCloseComplete}
        body={
          isLoading ? (
            <Loader />
          ) : expandedInvoice && customer ? (
            <InvoiceSummary
              expandedInvoice={expandedInvoice}
              companyName={customer.companyName || ''}
              invoiceActions={invoiceActions}
            />
          ) : null
        }
        header={
          expandedInvoice && customer ? (
            <DrawerHeader companyName={customer.companyName || ''} invoiceNumber={expandedInvoice.invoiceNumber} />
          ) : null
        }
        footer={
          expandedInvoice ? <DrawerFooter expandedInvoice={expandedInvoice} invoiceActions={invoiceActions} /> : null
        }
        data-testid="invoice-drawer-screen"
      />
    );
  }
);
InvoiceDrawerScreen.displayName = 'InvoiceDrawerScreen';
